<template>
  <div style="margin-top:70px;" >
    <Filters />
    <TabNavigation />
    <b-row
      v-if="this.$store.getters.filterSuprazone != null && this.$store.getters.filterGroup != 0"
      class="mt-3"
    >
      <bookings-check />
    </b-row>
    <b-row v-else>
      <b-col cols="12" class="mt-5">
        <div class="alert alert-danger text-center w-25">
          <i class="fa fa-fw fa-2x fa-exclamation-triangle"></i>
          <span class="text-center m-5 font-weight-bold" style="font-size: 1.2rem !important;">Por favor, seleccione datos para todos los desplegables de la parte superior de la pantalla</span>
        </div>
      </b-col>
      
    </b-row>
  </div>

</template>

<script>
/* eslint-disable */

import Filters from "../../components/Filters/Filters";
import TabNavigation from "../../components/Common/TabNavigation"
import BookingsCheck from '../../components/Excursions/Booking/BookingsCheck/BookingsCheck';
import { mapGetters } from "vuex";

export default {
  name: "Excursiones",
  components: {
    Filters,
    TabNavigation,
    BookingsCheck
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters(['activeTab']),
  }
};
</script>